__webpack_require__.p = "https://cdn.jsdelivr.net/gh/Azuriom/AzuriomInstaller@1.0.0/dist/";